const createQuery = () => `
  ... on KeyFactsWidget {
    title
    keyFacts {
      text
    }
  }
`
export default createQuery
